import React from 'react'

import Tag from './Tag'
import { MenuIcon } from 'lucide-react'
import { cn } from 'src/utils'

export type ControlProps = {
  tag?: React.ReactNode
  onClick?: () => any
  disabled?: boolean
}

export const Control = ({
  tag,
  children,
  className,
  onClick = () => {},
  disabled = false,
}: React.PropsWithChildren<ControlProps> &
  JSX.IntrinsicElements['div']) => (
  <div
    className={cn(
      `relative flex h-24 w-20 cursor-pointer flex-col justify-center rounded-md bg-white px-2 py-4 transition ease-in-out hover:bg-slate-300 hover:opacity-80`,
      disabled &&
        'pointer-events-none cursor-not-allowed opacity-50',
      className,
    )}
    onClick={onClick}
  >
    <div className="flex h-full select-none justify-center text-3xl">
      {children}
    </div>
    {tag}
  </div>
)

export type ControlsProps = {
  numVocab: number
  lang: string
  fromLang: string
  toLang: string
  onFlip: () => any
  onOptions: () => any
  onVocab: () => any
  flipDisabled?: boolean
}

const Controls = ({
  numVocab,
  lang,
  fromLang,
  toLang,
  onFlip,
  onOptions,
  onVocab,
  flipDisabled = false,
}: ControlsProps) => {
  const [fromLangId, fromVariant] = fromLang.split('-')
  const [toLangId, toVariant] = toLang.split('-')

  return (
    <div className="absolute bottom-0 left-0 grid w-full grid-cols-3 justify-items-center py-4">
      <Control
        onClick={onVocab}
        tag={
          <Tag
            style={{
              backgroundColor: '#8fe78a',
              color: 'black',
            }}
          >
            {numVocab}
          </Tag>
        }
      >
        <svg
          className="mt-[0.6rem] scale-[1.3]"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M8 21h12a2 2 0 0 0 2-2v-2H10v2a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v3h4" />
          <path d="M19 17V5a2 2 0 0 0-2-2H4" />
          <path d="M15 8h-5" />
          <path d="M15 12h-5" />
        </svg>
      </Control>
      {/* Additional settings? Review page? Progress? */}
      <Control onClick={onOptions}>
        <div className="scale[1.2] mb-6 flex items-center">
          <MenuIcon />
        </div>
      </Control>
      <Control onClick={onFlip} disabled={flipDisabled}>
        <div className="text-sm">
          <svg
            className="absolute right-[-6%] top-[24%] scale-[0.6]"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="10 15 15 20 20 15" />
            <path d="M4 4h7a4 4 0 0 1 4 4v12" />
          </svg>{' '}
          <svg
            className="absolute left-[11%] bottom-[36%] scale-[0.6]"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="15 10 20 15 15 20" />
            <path d="M4 4v7a4 4 0 0 0 4 4h12" />
          </svg>
          <Tag
            style={{
              color: toLang === lang ? 'black' : 'white',
              position: 'absolute',
              backgroundColor:
                toLang === lang
                  ? 'rgb(143, 231, 138)'
                  : 'gray',
              transform:
                toLang === lang
                  ? 'translate(-50%, 25%) scale(100%)'
                  : 'translate(-20%, 125%) scale(80%)',
              transition: 'all 0.2s ease-in-out',
            }}
          >
            {toLangId} {toVariant.toLocaleUpperCase()}
          </Tag>
          <Tag
            style={{
              color: 'white',
              position: 'absolute',
              backgroundColor:
                fromLang === lang ? '#bd99fe' : 'gray',
              transform:
                fromLang === lang
                  ? 'translate(-50%, 25%) scale(100%)'
                  : 'translate(-20%, 125%) scale(80%)',
              transition: 'all 0.2s ease-in-out',
            }}
          >
            {fromLangId} {fromVariant.toLocaleUpperCase()}
          </Tag>
        </div>
        {/* <WrapTextIcon /> */}
      </Control>
    </div>
  )
}
export default Controls
